<template>
  <ul class="form-item-list">
    <li><h3>다른 보험회사(우체국보험 및 각종 공제계약 판매사 포함) 에 생명보험, 손해보험, 제3보험 또는 각종 공제계약을 가입하고 있습니까?</h3></li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
    <li v-if="yes">
      <div class="detail-form">
        <el-row>
          <element-textbox
            v-model="detail['회사명'].value"
            :error="detail['회사명'].error"
            :label="detail['회사명'].label"
            :placeholder="detail['회사명'].placeholder"
            @input="changeDetail('회사명')"
          />
        </el-row>

        <el-row>
          <div class="label">{{ detail['건수'].label }}</div>
          <el-input
            type="text"
            v-model="detail['건수'].value"
            :placeholder="detail['건수'].placeholder"
            @input="changeDetail('건수')"
          >
            <span slot="suffix">건</span>
          </el-input>
        </el-row>

        <el-row>
          <div class="label">{{ detail['보험료'].label }}</div>
          <el-input
            type="text"
            v-model="detail['보험료'].value"
            :placeholder="detail['보험료'].placeholder"
            @input="changeDetail('보험료')"
          >
            <span slot="suffix">원</span>
          </el-input>
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'DeductionContract',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      detail: {
        '회사명': {
          label: "보험회사명",
          placeholder: '가입중인 보험회사명을 모두 입력해주세요',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        '건수': {
          label: "가입건수",
          placeholder: '예: 3',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        '보험료': {
          label: "월 보험료",
          placeholder: '예: 300,000',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
      }
    }
  },
  mounted() { 
    this.$emit('update', { type: '회사명', value: '' });
    this.$emit('update', { type: '건수', value: '' });
    this.$emit('update', { type: '보험료', value: '' });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
    changeDetail(key) {
      this.$emit('update', { type: key, value: this.detail[key].value });
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;

        & ::-webkit-input-placeholder { text-align:right; }
        & input:-moz-placeholder { text-align:right; }
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }
    }
  }
}
</style>